export const ASSIGNMENT_TYPE = {
  BENCHMARK: "BENCHMARK",
  PROGRESS_MONITORING: "PROGRESS_MONITORING",
  CALIBRATION: "CALIBRATION"
}

export const ASSIGNMENT_STATUS = {
  ASSIGNED: "ASSIGNED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  DONE: "DONE",
  ERROR: "ERROR",
  UNASSIGNED: "UNASSIGNED"
}

export const ASSIGNMENT_SEQUENCE = {
  CONTINUE: "CONTINUE",
  BREAK: "BREAK",
}

export const ENTITY_TYPE = {
  STUDENT: "STUDENT",
  CLASS: "CLASS",
  SCHOOL: "SCHOOL",
  DISTRICT: "DISTRICT",
}

export const ENTITY_ASSIGNMENT_ORDER = [
  ENTITY_TYPE.STUDENT,
  ENTITY_TYPE.CLASS,
  ENTITY_TYPE.SCHOOL,
  ENTITY_TYPE.DISTRICT,
];

export const GRADES = [
    "KINDERGARTEN",
    "FIRST",
    "SECOND",
    "THIRD",
    "FOURTH",
    "FIFTH",
    "SIXTH",
    "SEVENTH",
    "EIGHTH",
    "PRE_K",
];

export const TEMPLATE_TO_ACTIVITYTYPE = {
  DYSLEXIA: 'dyslexia',
  NWF: 'nwf',
  SPELLING: 'spelling',
  VOCABULARY_SCREENER: 'vocabularyScreener',
  LISTENING_COMPREHENSION: 'listeningComprehension',
  ASSESSMENT: 'assessment',
  READING_COMPREHENSION: 'readingComprehension'
}
